import { FunctionComponent, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { makeStyles, mergeClasses } from '@griffel/react'
import { tokens } from '@fluentui/tokens'
import { IFilter, useGenericListSettings, getParamId } from '@knowmax/genericlist-core'
import { SelectedFilter } from './SelectedFilter'

interface IFilterInfo {
  filter: IFilter
  value: string
}

const useClasses = makeStyles({
  list: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXS
  }
})

/** Shows list of filters currently serialized in params of query. */
export const SelectedFilterList: FunctionComponent<{ list: IFilter[], hiddenOnly?: boolean, allowClear?: boolean, listId?: string, className?: string }> = observer(({ list, hiddenOnly = true, allowClear = true, listId, className }) => {
  const classes = useClasses()
  const settings = useGenericListSettings()

  const infolist = useMemo<IFilterInfo[]>(() => {
    return list.map<IFilterInfo>((filter) => {
      const value = settings.params.get(getParamId(filter.id, listId))

      return {
        filter: filter,
        value: value ?? ''
      }
    }).filter((info) => {
      return info.value.trim() !== '' && (!hiddenOnly || info.filter.hidden === true)
    })
  }, [list, settings.params, hiddenOnly, listId])

  return (
    <div className={mergeClasses(classes.list, className)}>
      {infolist.map((info) => <SelectedFilter key={info.filter.id} filter={info.filter} value={info.value} allowClear={allowClear} listId={listId} />)}
    </div>
  )
})